import { connect } from 'react-redux'
import requestAddCardTemplate from '../../sagas/requestAddCardTemplate'
import requestCopyCard from '../../sagas/requestCopyCard'
import CopyCard from './CopyCard'

export default connect(
  (state, props) => {
    return {
      name: state['view-board'].cards[props.cardId].name,
      isTemplate: state['view-board'].cards[props.cardId].isTemplate,
    }
  },
  {
    requestCopyCard,
    requestAddCardTemplate,
  }
)(CopyCard)
